// extracted by mini-css-extract-plugin
export default {"ReadyPageContainer":"ReadyPage_ReadyPageContainer__WPCQa","header":"ReadyPage_header__irzLc"};